import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AddressService } from '@src/app/modules/address/address.service';
import { MiningService } from '@src/app/modules/hemera/agents/mining/mining.service';
import { MyProfileService } from '@src/app/modules/my-profile/my-profile.service';
import { CommonService } from '@src/app/services/common.service';
import { TelegramService } from '@src/app/services/telegram.service';
import { UserService } from '@src/app/services/user.service';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { SharedModule } from '@src/app/shared/shared.module';
import { AddressProfile } from '@src/app/shared/types/address.type';
import { tadaAnimation } from 'angular-animations';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { MyProfilePopupService } from '../../modules/my-profile/my-profile-popup.service';
import { CheckInWeekComponent } from '../check-in-week/check-in-week.component';
import { CheckInWeekService } from '../check-in-week/check-in-week.service';
import { FollowBtnComponent } from '../follow-btn/follow-btn.component';

@Component({
    selector: 'app-address-info-mobile',
    templateUrl: './address-info-mobile.component.html',
    styleUrls: ['./address-info-mobile.component.less'],
    standalone: true,
    animations: [tadaAnimation()],
    imports: [CommonModule, SharedModule, NzSkeletonModule, FollowBtnComponent],
    providers: [CheckInWeekService],
})
export class AddressInfoMobileComponent implements OnInit {
    @Input() walletAddress: string;

    walletProfile: AddressProfile;

    fetchingData = false;

    checkInAvailable = false;

    checkInAnimationIntervalId: any;

    checkInAnimationState = false;

    get isMe() {
        return !this.walletAddress || this.walletAddress?.toLowerCase() === this.walletStatusService.walletAddress?.toLowerCase();
    }

    get userProfile() {
        return this.walletAddress ? this.walletProfile : this.walletStatusService.userProfile;
    }

    get followersLink() {
        return `${this.walletAddress ? `/address/${this.walletAddress}/followers` : '/my-profile/followers'}`;
    }

    get followingsLink() {
        return `${this.walletAddress ? `/address/${this.walletAddress}/followings` : '/my-profile/followings'}`;
    }

    get myProfile() {
        return this.walletStatusService.userProfile;
    }

    get currentAvailableMiningTimes() {
        return this.miningService.userMiningProfile?.bonus_days + this.miningService.userMiningProfile?.days || 0;
    }

    get myAssetsInfo() {
        return this.myProfileService.assetsInfo;
    }

    constructor(
        private addressService: AddressService,
        public walletStatusService: WalletStatusService,
        public commonService: CommonService,
        public myProfilePopupService: MyProfilePopupService,
        public tgService: TelegramService,
        public userService: UserService,
        private myProfileService: MyProfileService,
        private miningService: MiningService,
        private modalService: NzModalService,
        private checkInWeekService: CheckInWeekService
    ) {}

    ngOnInit() {
        if (this.walletAddress) {
            this.addressService
                .getAddressProfile(this.walletAddress)
                .then(data => (this.walletProfile = data))
                .catch(err => this.commonService.errorMessageByResponse(err));
        }

        if (this.isMe) {
            this.addressService.getAddressTokenHoldings(this.walletStatusService.walletAddress).then(data => this.myProfileService.setAssetsInfo(data));
            this.miningService.getUserMiningStats().then(profile => (this.miningService.userMiningProfile = profile));

            this.checkInWeekService.getCheckInWeekInfo().then(data => {
                this.checkInAvailable = !data.login_today;

                if (!this.checkInAvailable) {
                    this.checkInAnimationIntervalId = setInterval(() => {
                        this.checkInAnimationState = !this.checkInAnimationState;
                    }, 3000);
                }
            });
        }
    }

    async sync() {
        this.fetchingData = true;
        await this.myProfileService.refreshAssets();
        await this.addressService.getAddressTokenHoldings(this.walletStatusService.walletAddress).then(data => this.myProfileService.setAssetsInfo(data));
        this.fetchingData = false;
    }

    openCheckInModal() {
        this.modalService.create({
            nzContent: CheckInWeekComponent,
            nzCentered: true,
            nzTitle: null,
            nzFooter: null,
            nzWidth: '700px',
            nzStyle: {
                maxWidth: '90vw',
            },
            nzBodyStyle: {
                'overflow-y': 'visible',
            },
            nzOnOk: () => clearInterval(this.checkInAnimationIntervalId),
            nzOnCancel: () => clearInterval(this.checkInAnimationIntervalId),
        });
    }
}
